import React, { useState, useEffect } from "react";
import DataTable from "../../../components/DataTable";
import { apiJson } from "../../../utils/api";

const CourseSeats = () => {
  const [sessions, setSessions] = useState([]);
  const [degrees, setDegrees] = useState([]);

  useEffect(() => {
    apiJson("/api/admin/master/academic-sessions").then(setSessions).catch(() => {});
    apiJson("/api/admin/master/degrees").then(setDegrees).catch(() => {});
  }, []);

  return (
    <DataTable
      title="Course Seats"
      apiPath="/api/admin/master/course-seats"
      columns={[
        { key: "id", label: "ID" },
        { label: "Session", render: (i) => i.academicSession?.name || "-" },
        { label: "Degree", render: (i) => i.degree?.name || "-" },
        { key: "totalSeats", label: "Total Seats" },
      ]}
      formFields={[
        {
          key: "academicSessionId",
          label: "Academic Session",
          type: "select",
          required: true,
          options: sessions.map((s) => ({ value: s.id, label: s.name })),
        },
        {
          key: "degreeId",
          label: "Degree",
          type: "select",
          required: true,
          options: degrees.map((d) => ({ value: d.id, label: d.name })),
        },
        { key: "totalSeats", label: "Total Seats", type: "number", required: true },
      ]}
    />
  );
};

export default CourseSeats;
